import React from "react";

import "./style.scss";

const ExperienceEditorComponentPlaceholder = ({ text }) => (
  <div className="ExperienceEditorComponentPlaceholder">{text}</div>
);

export default ExperienceEditorComponentPlaceholder;
